(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/components/tables/bomben-table.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/components/tables/bomben-table.js');
"use strict";


const {
  Flag
} = svs.tt.components;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const BombenTable = _ref => {
  let {
    draw
  } = _ref;
  return React.createElement("table", {
    "aria-label": "".concat(draw.description, " matchlista"),
    className: "table table-default tt-matchlist-table margin-top-1"
  }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Nr"), React.createElement("th", null, "Matchstart"), React.createElement("th", null, "Match"), React.createElement("th", null, "Liga"), React.createElement("th", null, "Match-ID"))), React.createElement("tbody", null, (draw.events || []).map((event, idx) => React.createElement("tr", {
    className: idx % 2 === 0 ? '' : 'table-row-striped',
    key: event.eventNumber
  }, React.createElement("td", null, event.eventNumber), React.createElement("td", null, formatDate(event.match && event.match.matchStart, true, false, false, true)), React.createElement("td", null, event.eventDescription), React.createElement("td", null, React.createElement(Flag, {
    country: event.match && event.match.league && event.match.league.country
  }), React.createElement("span", {
    className: "align-middle"
  }, event.match && event.match.league && event.match.league.name)), React.createElement("td", {
    className: "selectable-text"
  }, event.match && event.match.matchId)))));
};
setGlobal('svs.tt.components.BombenTable', BombenTable);

 })(window);